export { default as TLAddPostalArea } from './AddPostalArea';
export { default as TLSelectMunicipal } from './SelectMunicipal';
export { default as TLSelectPostalArea } from './SelectPostalArea';
